var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8451 18.9071C21.3315 19.3012 24.566 20.1588 25.1298 17.9103C25.705 15.6098 22.5625 14.915 21.0239 14.5748C20.8495 14.5362 20.6958 14.5022 20.5704 14.471L19.4836 18.8131C19.5871 18.8387 19.7088 18.871 19.8451 18.9071Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1609 25.8982C19.9413 26.3672 23.835 27.3929 24.4546 24.9152C25.0887 22.3819 21.3133 21.538 19.4712 21.1263C19.2656 21.0803 19.0839 21.0397 18.9353 21.0028L17.7367 25.7883C17.8584 25.8185 18.0013 25.8561 18.1609 25.8982Z",
    fill: "#F7931A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1153 20.3084C40.1153 31.2484 31.2471 40.117 20.3076 40.117C9.36818 40.117 0.5 31.2484 0.5 20.3084C0.5 9.36837 9.36818 0.499756 20.3076 0.499756C31.2471 0.499756 40.1153 9.36837 40.1153 20.3084ZM25.0663 12.9488C27.8217 13.895 29.8372 15.3118 29.4418 17.9486C29.1546 19.8794 28.0803 20.8133 26.6529 21.1402C28.6112 22.1558 29.2786 24.0832 28.6585 26.4138C27.481 29.7676 24.6821 30.05 20.9595 29.349L20.0556 32.9543L17.8734 32.4118L18.7649 28.8549C18.1992 28.7149 17.621 28.565 17.0255 28.4053L16.1302 31.9796L13.9506 31.4371L14.8533 27.8244L10.458 26.7197L11.5422 24.2303C11.5422 24.2303 13.1511 24.6551 13.1287 24.6241C13.7467 24.7765 14.0215 24.3752 14.1296 24.1089L16.5791 14.3235C16.6064 13.8615 16.446 13.2794 15.562 13.059C15.5956 13.0355 13.9767 12.6664 13.9767 12.6664L14.5574 10.3442L18.9589 11.4304L19.8541 7.85852L22.035 8.40098L21.1584 11.9022C21.7453 12.0348 22.3347 12.1697 22.9079 12.3122L23.7782 8.83322L25.9603 9.37569L25.0663 12.9488Z",
    fill: "#F7931A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/BTC.340d24f337394c846a9a109dddd63965.svg";
export { ForwardRef as ReactComponent };